import { Injectable } from '@angular/core';
import { over } from '@element451-libs/immutable-deep-update';
import { SerializablePage451Component } from '@element451-libs/page451-lib';
import {
  replaceToken,
  TokensReplaceMap
} from '@element451-libs/utils451/tokens';
import { reduce } from 'lodash';
import { Observable, of } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { ConfigService } from '../../core';

const USER_TOKEN_MAP: { [key: string]: string } = {
  // TOKEN : USER PROPERTY
  '[user:first_name]': 'first_name',
  '[user:user-first-name]': 'first_name',
  '[user:last_name]': 'last_name',
  '[user:user-last-name]': 'last_name',
  '[user:middle_name]': 'middle_name',
  '[user:user-middle-name]': 'middle_name'
};

@Injectable()
export class App451TokensService {
  private clientTokens: TokensReplaceMap[];

  constructor(private configService: ConfigService) {
    this.clientTokens = [
      {
        token: '[client:name]',
        value: this.configService.getClient().clientName
      }
    ];
  }

  replaceTextTokens(text: string) {
    return this.getTokensMap().pipe(
      take(1),
      map(tokens => replaceToken(text, tokens))
    );
  }

  replaceStaticTokens(text: string) {
    return replaceToken(text, this.clientTokens);
  }

  getTokensMap(): Observable<TokensReplaceMap[]> {
    return of([]);
  }

  replaceTokens(
    rows: SerializablePage451Component[],
    config: any
  ): Observable<SerializablePage451Component[]> {
    return this.getTokensMap().pipe(
      map(tokensMap => this._replaceTokens(rows, tokensMap, config))
    );
  }

  replaceToken(
    row: SerializablePage451Component,
    config: any
  ): Observable<SerializablePage451Component> {
    return this.getTokensMap().pipe(
      map(tokensMap => this._replaceToken(row, tokensMap, config))
    );
  }

  private _replaceTokens(
    rows: SerializablePage451Component[],
    tokensMap: TokensReplaceMap[],
    config: any
  ): SerializablePage451Component[] {
    return rows.map(row => this._replaceToken(row, tokensMap, config));
  }

  private _replaceToken(
    row: SerializablePage451Component,
    tokensMap: TokensReplaceMap[],
    config: any
  ): SerializablePage451Component {
    if (!config[row.type] || !config[row.type].length) return row;
    return reduce(
      config[row.type],
      (result, prop) => {
        return over(prop, text => replaceToken(text, tokensMap), result);
      },
      row
    );
  }
}
